<div class="w-full h-full bg-pattern flex flex-col items-center justify-center ng-tns-c241-103">
  <div class="d-flex align-items-center justify-content-end brand">
    <img style="margin: 0px auto" src="/assets/img/login/logo.svg" alt="webtest logo" />
  </div>
  <h1 style="color: #092056; font-weight: 600;">Registration</h1>

  <div class="card p-4 m-4" *ngIf="showSignUp || showCode">
    <!-- Sign Up -->
    <div class="" *ngIf="showSignUp">

      <div class="form-group">
        <label style="color: #092056; font-weight: 600;">Company Name</label>
        <div class="input-group mb-3">
          <div class="input-group-append">
            <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:person"></mat-icon></span>
          </div>
          <input type="text" class="form-control" placeholder="Company Name" [(ngModel)]="clienAccount.companyName"
            [ngModelOptions]="{ standalone: true }">
        </div>
      </div>

      <div class="form-group mb-3">
        <label style="color: #092056; font-weight: 600;">Company Email</label>

        <div class="input-group">
          <div class="input-group-append">
            <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:email"></mat-icon></span>
          </div>
          <input id="companyEmail" #companyEmail="ngModel" type="email" class="form-control" placeholder="Company Email"
            [(ngModel)]="clienAccount.companyEmail" [ngModelOptions]="{ standalone: true }" [pattern]="emailPattern">
        </div>
        <span class="text-warning" *ngIf="companyEmail.errors && companyEmail.errors.pattern">Invalid Email
          Format</span>
      </div>

      <div class="form-group">
        <label style="color: #092056; font-weight: 600;">Password</label>

        <div class="input-group mb-3">
          <div class="input-group-append">
            <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:lock"></mat-icon></span>
          </div>
          <input type="password" class="form-control" placeholder="Password" [(ngModel)]="clienAccount.password"
            [ngModelOptions]="{ standalone: true }">
        </div>
      </div>

      <div class="form-group">
        <label style="color: #092056; font-weight: 600;">Confirm Password</label>

        <div class="input-group">
          <div class="input-group-append">
            <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:lock"></mat-icon></span>
          </div>
          <input type="password" class="form-control" placeholder="Confirm Password" [(ngModel)]="confirmPassword"
            [ngModelOptions]="{ standalone: true }">
        </div>
        <span class="text-warning" *ngIf="clienAccount.password!==confirmPassword && confirmPassword!==''">Password
          Mismatch</span>
      </div>
      <a routerLink="/login" class="d-flex justify-content-left align-items-left">Have An Account Login</a>
    </div>
    <!-- Code -->
    <div class="form-group" *ngIf="showCode">
      <label style="color: #092056; font-weight: 600;">Verification Code</label>

      <div class="input-group mb-3">
        <div class="input-group-append">
          <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:key"></mat-icon></span>
        </div>
        <input type="email" class="form-control" placeholder="Verification Code" [(ngModel)]="codeText"
          [ngModelOptions]="{ standalone: true }">
      </div>
      <span class="d-flex justify-content-end align-items-end text-primary" style="cursor: pointer;"
        (click)="sendCode()">Resend Code</span>

    </div>
    <button class="d-flex justify-content-center align-items-center btn login-btn px-4" (click)="saveClient()"
      *ngIf="showSignUp"
      [disabled]="(clienAccount.password!==confirmPassword && confirmPassword!=='') || clienAccount.companyEmail==='' ">
      <span style=" width:fit-content ; margin: 0px auto">Sign Up</span>
    </button>
    <button class="d-flex justify-content-center align-items-center btn login-btn px-4" (click)="verifyEmail()"
      *ngIf="showCode">
      <span style=" width:fit-content ; margin: 0px auto">Verify Code</span>
    </button>
  </div>

  <div class="card p-4 m-4" style="width: 75%;" *ngIf="showForm">
    <form (ngSubmit)="updateClient()">
      <!-- Company -->
      <div class="row mb-3">
        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Company Name</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:person"></mat-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Company Name" [(ngModel)]="clienAccount.companyName"
                [ngModelOptions]="{ standalone: true }" [disabled]="true">
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Company Email</label>

            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:email"></mat-icon></span>
              </div>
              <input type="email" class="form-control" placeholder="Company Email"
                [(ngModel)]="clienAccount.companyEmail" [ngModelOptions]="{ standalone: true }" [disabled]="true">
            </div>

          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Company Website URL</label>

            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:public"></mat-icon></span>
              </div>
              <input type="url" class="form-control" placeholder="www.example.com"
                [(ngModel)]="clienAccount.companyWebsite" [ngModelOptions]="{ standalone: true }" />

            </div>

          </div>
        </div>
      </div>

      <!-- Business -->
      <div class="row mb-3">
        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Company Registration Number</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:dialpad"></mat-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Company Registration Number"
                [(ngModel)]="clienAccount.companyRegistrationNo" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Company Phone No.</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text">
                  <mat-icon class="icon-sm" svgIcon="mat:phone"></mat-icon></span>
              </div>
              <input type="tel" class="form-control" placeholder="Company Phone No."
                [(ngModel)]="clienAccount.companyPhoneNo" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Company Certificate</label>
            <div class="input-group mb-3">
              <!-- <div class="input-group-append">
          <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:library_books"></mat-icon></span>
        </div> -->
              <input type="file" class="form-control" placeholder="Recipient's username" (change)="onFileChange($event)"
                [(ngModel)]="clienAccount.companyCertificate" [ngModelOptions]="{ standalone: true }"
                accept="image/png, image/jpeg" />
            </div>
          </div>
        </div>

      </div>

      <!-- Contacts -->
      <div class="row mb-3">
        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Contact Person Name</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:person"></mat-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Contact Person Name"
                [(ngModel)]="clienAccount.contactPersonName" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Contact Person Phone No.</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:phone"></mat-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Contact Person Phone No."
                [(ngModel)]="clienAccount.contactPersonPhoneNo" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label style="color: #092056; font-weight: 600;">Contact Person Email</label>

            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text"><mat-icon class="icon-sm" svgIcon="mat:email"></mat-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Contact Person Email"
                [(ngModel)]="clienAccount.contactPersonEmail" [ngModelOptions]="{ standalone: true }" />
            </div>

          </div>
        </div>
      </div>

      <!-- Submit -->
      <div class="d-flex flex-column">
        <button type="submit" class="d-flex justify-content-center align-items-center btn login-btn px-4">
          <span style=" width:fit-content ; margin: 0px auto">Submit</span>
        </button>
      </div>

    </form>

  </div>

</div>